export const appRole = {
    SUPER_ADMIN: 'Super Admin',
    ADMIN: 'Admin',
    USER: 'USER',
};
